import { Vue, Component, Prop } from 'vue-property-decorator'
import AvailableSvg from '~/assets/svg/available.svg?inline'
import ExpectedSvg from '~/assets/svg/expected.svg?inline'
import UnavailableSvg from '~/assets/svg/unavailable.svg?inline';

interface PointData {
  id: string,
  name: string,
  amountInPharmacy: number,
  amountInProvider: number,
  amountNotAvailable: number,
  dateDelivery: Date | null
}

@Component
export default class BalloonContent extends Vue {
  @Prop({ required: true }) point!: PointData

  onConfirm () {
    this.$emit('confirm', this.point.id)
  }

  render () {
    return (
      <div class="balloon-content-site">
        <div><strong>{this.point.name}</strong></div>
        <div class="pickup-selector-popup-mobile__availability">
          {(this.point.amountInPharmacy > 0) && (
            <div class="status_available">
              <AvailableSvg/>
              <p class="status_available--count">Товары есть в наличии: {this.point.amountInPharmacy} </p>
            </div>
          )}
          {(this.point.amountInProvider > 0) && (
            <div class="status_expected">
              <div class="status_expected--container">
                <ExpectedSvg/>
                <p class="status_expected--count">Товары ожидаются: {this.point.amountInProvider}</p>
              </div>
              <p class="status_expected--date">Товары ожидаются в этой аптеке с {this.point.dateDelivery}</p>
            </div>
          )}
          {(this.point.amountNotAvailable > 0) &&
            <div class="status_unavailable">
              <div class="status_unavailable--container">
                <UnavailableSvg />
                <p class="status_unavailable--count">
                  Товары недоступны в этой аптеке: {this.point.amountNotAvailable}
                </p>
              </div>
            </div>
          }
          {(this.point.amountInPharmacy > 0 || this.point.amountInProvider > 0) &&
            <button class="catalog-button balloon" onClick={this.onConfirm} style="margin-top: 8px; padding: 5px 10px;">Выбрать</button>
          }
        </div>
      </div>
    )
  }
}
